import HomeCover from './HomeCover';

export default HomeCover;
